import { useOutletContext } from "react-router";
import type { CustomerDetailVisibleScope } from "@acto/ambient-context-schema";
import { useLocale } from "@acto/web-common/locales";
import { useContributeChatScope, customerToInfo } from "@acto/taskpane/core/chat-envelope";
import type { CustomerOutletContext } from "@acto/taskpane/field-sales-2/CustomerDetailsLayout";

type CustomerDetailTab = CustomerDetailVisibleScope["active_tab"];

/**
 * Contributes the customer-detail scope shared by every tab (active_tab +
 * customer_info) merged with the tab's own fragment. Call from the tab PAGE —
 * contributions are keyed by pathname, so the layout can't do it once for all
 * tabs. `fragment` must be referentially stable across renders.
 */
export function useContributeCustomerDetailScope(
  tab: CustomerDetailTab,
  fragment: Partial<CustomerDetailVisibleScope> = {},
): void {
  const { customer } = useOutletContext<CustomerOutletContext>();
  const { locale } = useLocale();

  const merged = {
    active_tab: tab,
    ...(customer ? customerToInfo(customer, locale) : {}),
    ...fragment,
  };
  useContributeChatScope("customer-detail", merged);
}
